<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="submit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="form-floating mb-3">
				<input type="text" id="name" class="form-control" name="name" [(ngModel)]="data.name" required />
				<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
			<div class="form-floating mb-3">
				<input type="text" id="code" class="form-control" name="code" [(ngModel)]="data.code" required />
				<label for="name" class="form-label">Kod<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
			<div class="mb-3">
				<ng-select
					id="kind"
					name="kind"
					class="custom-ng-select"
					matTooltip="Pokój nie posiada aneksu kuchennego; Studio to pokój z aneksem kuchennym; Apartemant to studio z więcej niż 1 pokojem"
					[(ngModel)]="data.kind"
					placeholder="Rodzaj pokoju"
					required
				>
					<ng-option *ngFor="let item of roomKind" [value]="item.kind">{{ item.name }}</ng-option>
				</ng-select>
			</div>
			<div matTooltip="Nazwa łóżka | Liczba łóżek | Maksymalny wiek" class="mb-3">
				<ng-select
					id="configuration"
					name="configuration"
					class="custom-ng-select"
					[(ngModel)]="data.configurations"
					placeholder="Konfiguracja łóżek"
					multiple="true"
					required
				>
					<ng-option *ngFor="let item of beds" [value]="item.id">
						{{ item.kind }} | {{ item.count }} | {{ item.maxAge }}</ng-option
					>
				</ng-select>
			</div>
		</fieldset>
	</form>
</div>
